import axios from 'axios'

axios.interceptors.request.use(function (config) {
  config.headers['Request-Application'] = 'agus-dashboard'
  return config;
});